import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import VideoPage from './pages/VideoPage';
import BookingPage from './pages/BookingPage';
import ThankYouPage from './pages/ThankYouPage';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/video" element={<VideoPage />} />
          <Route path="/book" element={<BookingPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;